import fox from "./images/utsav.jpg";
import jill from "./images/Ram.jpg";
import cha2 from "./images/Mata-Sharda-devi.jpg";
import cha1 from "./images/orcha.jpg";
import c2 from "./images/bhedaghat.jpg";


export default [fox, jill, cha2, cha1, c2];